import { __assign } from "tslib";
import { filterXSS, whiteList as externalXSSWhitelist } from 'xss';
var ALLOWED_PREFIX_ATTRIBUTES = ['data', 'aria'];
var ALLOWED_ATTRIBUTES = [
    'style',
    'class',
    'id',
    'dir',
    'wix-comp',
    'role',
    'tabindex',
    'focus',
    'contenteditable',
    'spellcheck',
    'scope',
];
var ALLOWED_LINK_ATTRIBUTES = ['href', 'dataquery', 'id', 'rel', 'target', 'class', 'style'];
var CSS_PROPS_WHITELIST = [
    'color',
    'background-color',
    'font-size',
    'font-family',
    'font-style',
    'text-decoration',
    'writing-mode',
    'text-orientation',
    'line-height',
    'text-shadow',
    'direction',
    'position',
    'z-index',
    'top',
    'bottom',
    'left',
    'right',
    'overflow',
    'overflow-x',
    'overflow-y',
    'height',
    'width',
    'max-height',
    'max-width',
];
function generateHTMLWhiteList() {
    var _a;
    var whitelist = __assign(__assign({}, externalXSSWhitelist), { strike: [], hatul: [], wline: [], object: [] });
    if (whitelist.a) {
        (_a = whitelist.a).push.apply(_a, ALLOWED_LINK_ATTRIBUTES);
    }
    Object.keys(whitelist).forEach(function (key) {
        var _a;
        if (!whitelist[key]) {
            whitelist[key] = [];
        }
        (_a = whitelist[key]).push.apply(_a, ALLOWED_ATTRIBUTES);
    });
    return whitelist;
}
function generateCSSWhiteList() {
    return CSS_PROPS_WHITELIST.reduce(function (acc, key) {
        acc[key] = true;
        return acc;
    }, {});
}
var XSSWhitelist = generateHTMLWhiteList();
var CSSWhitelist = generateCSSWhiteList();
export function sanitizeHTML(html) {
    return filterXSS(html, {
        whiteList: XSSWhitelist,
        stripIgnoreTagBody: ['script', 'style'],
        stripBlankChar: true,
        css: { whiteList: __assign(__assign({}, externalXSSWhitelist), CSSWhitelist) },
        onIgnoreTagAttr: function (tag, name, value) {
            if (ALLOWED_PREFIX_ATTRIBUTES.some(function (prefix) { return name.startsWith(prefix); })) {
                return "".concat(name, "=\"").concat(value, "\"");
            }
            return '';
        },
        onIgnoreTag: function () {
            return '';
        },
    });
}
//# sourceMappingURL=sanitizeHTML.js.map